<template>
    <div id="geonotificationsHistoryList" class="baseTemplate">
        <!-- begin:: mobile menu -->
        <app-mobilemenu></app-mobilemenu>
        <!-- end:: mobile menu -->

        <div class="kt-grid kt-grid--hor kt-grid--root">
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                <!-- begin:: home menu -->
                <app-siteconfigurationmenu activeItem="geonotificationsHistory"></app-siteconfigurationmenu>
                <!-- end:: home menu -->

                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
                    <!-- begin:: header -->
                    <app-header></app-header>
                    <!-- end:: header -->

                    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                        <!-- begin:: Content Head -->
                        <div class="kt-subheader kt-grid__item">
                            <app-sitetitle subHeaderDescKey="geo_notif_alarmsListSubTitle"></app-sitetitle>
                            <div class="kt-subheader__toolbar">
                                <div class="kt-subheader__wrapper" v-if="!isEmptyList">
                                    <button @click="acknowledgeAllForSite()" id="acknowledgeAllForSiteButton" class="btn btn-brand btn-bold btn-sm btn-icon-h kt-margin-l-10">
                                        <i class="la la-check kt-margin-t-1 kt-margin-r-5"></i>
                                        {{ $t("alarm_acknowledgeAll") }}
                                    </button>
                                    <button @click="deleteAllForSite()" id="deleteAllForSiteButton" class="btn btn-danger btn-bold btn-sm btn-icon-h kt-margin-l-10">
                                        <i class="la la-trash kt-margin-t-1 kt-margin-r-5"></i>
                                        {{ $t("geo_notif_deleteAll") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- end:: Content Head -->

                        <div class="kt-content kt-grid__item kt-grid__item--fluid">
                            <div class="kt-portlet">
                                <div class="kt-portlet__body kt-portlet__body--fit">
                                    <div class="row row-no-padding row-col-separator-xl">
                                        <div class="col-md-12 col-lg-12 col-xl-3">
                                            <!--begin:: Widgets/Stats2-1 -->
                                            <div class="kt-widget1">
                                                <div class="kt-widget1__item">
                                                    <div class="kt-widget1__info" data-cy="home_widget_info_sites">
                                                        <h3 class="kt-widget1__title">{{ $t("common_total") }}</h3>
                                                        <span class="kt-widget1__desc">{{ $t("geo_notif_totalNumberOfNotif") }}</span>
                                                    </div>
                                                    <span class="kt-widget1__number kt-font-dark" style=" font-size: 2rem; ">{{ totalGeonotificationsHistory || 0 }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-lg-12 col-xl-3">
                                            <div class="kt-widget1">
                                                <div class="kt-widget1__item">
                                                    <div class="kt-widget1__info" data-cy="home_widget_info_sitesInProduction">
                                                        <h3 class="kt-widget1__title">{{ $t("geo_notif_unacknowledgeds") }}</h3>
                                                        <span class="kt-widget1__desc">{{ $t("geo_notif_numberOfUnackNotif") }}</span>
                                                    </div>
                                                    <span class="kt-widget1__number kt-font-success" style=" font-size: 2rem; ">{{ newNotificationsForSite }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-lg-12 col-xl-3">
                                            <!--begin:: Widgets/Stats2-3 -->
                                            <div class="kt-widget1">
                                                <div class="kt-widget1__item">
                                                    <div class="kt-widget1__info" data-cy="home_widget_info_Applications">
                                                        <h3 class="kt-widget1__title">{{ $t("geo_notif_acknowledgeds") }}</h3>
                                                        <span class="kt-widget1__desc">{{ $t("geo_notif_numberOfAckNotif") }}</span>
                                                    </div>
                                                    <span class="kt-widget1__number kt-font-brand" style=" font-size: 2rem; ">{{ acknowledgedNotificationsForSite }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-lg-12 col-xl-3">
                                            <div class="kt-widget1">
                                                <div class="kt-widget1__item">
                                                    <div class="kt-widget1__info" data-cy="home_widget_info_Applications">
                                                        <h3 class="kt-widget1__title">{{ $t("geo_notif_lastHour") }}</h3>
                                                        <span class="kt-widget1__desc">{{ $t("geo_notif_numberOfLastHourNotif") }}</span>
                                                    </div>
                                                    <span class="kt-widget1__number kt-font-danger" style=" font-size: 2rem; ">{{ lastHourNotificationsForSite }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- begin:: Content -->
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="kt-portlet kt-portlet--height-fluid kt-portlet--mobile">
                                        <div class="kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm">
                                            <div class="kt-portlet__head-label">
                                                <span class="kt-portlet__head-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24" />
                                                            <path d="M10.9630156,7.5 L11.0475062,7.5 C11.3043819,7.5 11.5194647,7.69464724 11.5450248,7.95024814 L12,12.5 L15.2480695,14.3560397 C15.403857,14.4450611 15.5,14.6107328 15.5,14.7901613 L15.5,15 C15.5,15.2109164 15.3290185,15.3818979 15.1181021,15.3818979 C15.0841582,15.3818979 15.0503659,15.3773725 15.0176181,15.3684413 L10.3986612,14.1087258 C10.1672824,14.0456225 10.0132986,13.8271186 10.0316926,13.5879956 L10.4644883,7.96165175 C10.4845267,7.70115317 10.7017474,7.5 10.9630156,7.5 Z" fill="#000000" />
                                                            <path d="M7.38979581,2.8349582 C8.65216735,2.29743306 10.0413491,2 11.5,2 C17.2989899,2 22,6.70101013 22,12.5 C22,18.2989899 17.2989899,23 11.5,23 C5.70101013,23 1,18.2989899 1,12.5 C1,11.5151324 1.13559454,10.5619345 1.38913364,9.65805651 L3.31481075,10.1982117 C3.10672013,10.940064 3,11.7119264 3,12.5 C3,17.1944204 6.80557963,21 11.5,21 C16.1944204,21 20,17.1944204 20,12.5 C20,7.80557963 16.1944204,4 11.5,4 C10.54876,4 9.62236069,4.15592757 8.74872191,4.45446326 L9.93948308,5.87355717 C10.0088058,5.95617272 10.0495583,6.05898805 10.05566,6.16666224 C10.0712834,6.4423623 9.86044965,6.67852665 9.5847496,6.69415008 L4.71777931,6.96995273 C4.66931162,6.97269931 4.62070229,6.96837279 4.57348157,6.95710938 C4.30487471,6.89303938 4.13906482,6.62335149 4.20313482,6.35474463 L5.33163823,1.62361064 C5.35654118,1.51920756 5.41437908,1.4255891 5.49660017,1.35659741 C5.7081375,1.17909652 6.0235153,1.2066885 6.2010162,1.41822583 L7.38979581,2.8349582 Z" fill="#000000" opacity="0.3" />
                                                        </g>
                                                    </svg>
                                                </span>
                                                <h3 class="kt-portlet__head-title">{{ $t("geo_notif_history") }}</h3>
                                            </div>
                                            <div v-if="!isEmptyList" class="kt-portlet__head-toolbar">
                                                <button @click="onExportGeoNotificationsHistory" id="geonotificationsHistory_exportGeoNotificationsHistoryFromXLSButton" class="exportXLSXButton btn btn-sm btn-outline-success kt-margin-l-10">
                                                    <i class="fa fa-file-excel kt-margin-r-5"></i>
                                                    {{ $t("common_exportFromXLSFile") }}
                                                </button>
                                            </div>
                                        </div>
                                        <!--begin emptyList component-->
                                        <app-emptylist targetObjectName="GEONOTIFICATION_LIST" mainTextKey="alarm_emptyAlarmHistory" subTextKey="alarm_emptyAlarmHistorySubLabel" imgName="empty_notifications.svg" v-bind:isDisplayed="isEmptyList"></app-emptylist>
                                        <!--end emptyList component-->
                                        <div class="kt-portlet__body kt-portlet__body--fit">
                                            <!--begin: Datatable -->
                                            <div class="kt-datatable" id="notifications_datatable"></div>
                                            <!--end: Datatable -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end:: Content -->
                        </div>
                    </div>

                    <!-- begin:: Footer -->
                    <app-footer></app-footer>
                    <!-- end:: Footer -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from "../../i18n";
import EmptyList from "./../utils/emptylist.vue";
import SiteTitle from "../site/widgets/sitetitle.vue";
import moment from "moment";
import commonVueHelper from "../../helpers/commonVueHelper";

const xlMomentDateFormat = commonVueHelper.getXlDateTimezoneFormat();

export default {
    data() {
        return {
            baseURL: process.env.VUE_APP_BACKEND_URL,
            siteId: this.$route.params.siteId,
            siteNotificationsTable: null,
            isEmptyList: false,
            searchedValue: "",
            authorization: "Bearer " + localStorage.getItem("token"),
            limit: null,
            offset: null,
            sort: null,
            field: null,
            isGetGeonotificationAlarmsForSiteToExport: false,
            totalGeonotificationsHistory: 0,
            unAcknowledgedGeonotificationsHistory: 0,
            acknowledgedGeonotificationsHistory: 0,
            lastHourNotificationsHistory: 0
        };
    },
    created: function() {
        console.log("Component(GeonotificationsHistory)::created() - called");
        this.getGeonotificationAlarmsForSite({ siteId: this.siteId, limit: this.limit || 50, offset: this.offset || 0 });
    },
    mounted: function() {
        console.log("Component(GeonotificationsHistory)::mounted() - Init metronic layout");
        KTLayout.init();
    },
    beforeDestroy: function() {
        console.log("Component(GeonotificationsHistory)::beforeDestroy() - called");
        this.searchedValue = "";
        // Reset component data
        if (this.siteNotificationsTable) {
            this.siteNotificationsTable.destroy();
            this.siteNotificationsTable = null;
        }
    },
    destroyed: function() {
        console.log("Component(GeonotificationsHistory)::destroyed() - called");
        this.resetAlarmsState();
    },
    watch: {
        // -- Watch -- Property to perform asynchronous or expensive operations in response to changing component "data".
        // --
        currentSiteGeonotificationAlarms: function(currentSiteGeonotificationAlarms) {
            console.log("Component(GeonotificationsHistory)::watch(currentSiteGeonotificationAlarms) - called with ", currentSiteGeonotificationAlarms);
            if (currentSiteGeonotificationAlarms && !this.isGetGeonotificationAlarmsForSiteToExport) {
                this.initKtDataTable();
            }

            if (this.isGetGeonotificationAlarmsForSiteToExport) {
                this.exportGeoNotificationsHistoryModal();
                this.isGetGeonotificationAlarmsForSiteToExport = false;
            }
        },
        user: function(user) {
            if (user) {
                console.log("Component(GeonotificationsHistory)::watch(user) called with :", user);
                this.initKtDataTable();
            }
        }

    },
    computed: {
        // -- Computed -- Property will only re-evaluate when some of its reactive dependencies have changed.
        // To compose new data from existing datasource
        // To reference a value from the template (cached value)
        // --
        ...mapGetters(["user", "currentSiteGeonotificationAlarms"]),

        siteAlarms: function() {
            console.log("Component(GeonotificationsHistory)::computed(siteAlarms) - called ");
            if (this.currentSiteGeonotificationAlarms) {
                return this.currentSiteGeonotificationAlarms;
            }
            return [];
        },

        newNotificationsForSite: function() {
            let result = 0;
            if (this.unAcknowledgedGeonotificationsHistory && this.unAcknowledgedGeonotificationsHistory > 0) {
                result = this.unAcknowledgedGeonotificationsHistory;
            }
            return result;
        },

        acknowledgedNotificationsForSite: function() {
            let result = 0;
            if (this.acknowledgedGeonotificationsHistory && this.acknowledgedGeonotificationsHistory > 0) {
                result = this.acknowledgedGeonotificationsHistory;
            }
            return result;
        },

        lastHourNotificationsForSite: function() {
            let result = 0;
            if (this.lastHourNotificationsHistory && this.lastHourNotificationsHistory > 0) {
                // var nowMinusOneHour = moment().subtract(1, 'hours');
                // for (let alarm of this.currentSiteGeonotificationAlarms) {
                //     if (alarm && moment(alarm.issuedAt).isAfter(nowMinusOneHour)) {
                //         result += 1;
                //     }
                // }
                result = this.lastHourNotificationsHistory;
            }
            return result;
        }

    },
    methods: {
        // -- Methods -- Property to perform an action.
        // To react on some event happening in the DOM (called every time an event occurs even if method returns the same result)
        // To call a function when something happens in your component (from property "computed" or "watch")
        // ---
        ...mapActions([
            "getGeonotificationAlarmsForSite",
            "acknowledgeAlarm",
            "showDeleteModal",
            "acknowledgeGeonotificationAlarms",
            "deleteGeonotificationAlarms",
            "setSiteAlarm",
            "resetAlarmsState",
            "acknowledgeAllGeonotificationAlarmsForSite",
            "deleteAllGeonotificationAlarmsForSite"
        ]),

        acknowledgeAllForSite() {
            // this.acknowledgeGeonotificationAlarms({ siteId: this.siteId, isAcknowledgeAllForSite: true });
            this.acknowledgeAllGeonotificationAlarmsForSite(this.siteId);
        },

        deleteAllForSite() {
            // this.deleteGeonotificationAlarms({ siteId: this.siteId, isDeleteAllForSite: true });
            this.deleteAllGeonotificationAlarmsForSite(this.siteId);
        },

        onEditGeofence: function(tagId) {
            this.$router.push({
                name: "geofences",
                params: { siteId: this.siteId }
            });
        },

        onOpenLastPositionURLButton: function(lastPositionUrl) {
            window.open(lastPositionUrl, '_blank');
        },

        onAcknowledgeAlarm: function(alarmId) {
            this.acknowledgeAlarm({ alarmId: alarmId, siteId: this.siteId, limit: this.limit, offset: this.offset });
        },

        onEditAsset: function(assetId) {
            this.$router.push({
                name: "editAsset",
                params: { assetId: assetId }
            });
        },

        registerEventsOnSiteNotificationsTable() {
            var self = this;

            console.log("Component(GeonotificationsHistory)::registerEventsOnSiteNotificationsTable - called");

            $("#notifications_datatable").on(
                "kt-datatable--on-layout-updated",
                () => {
                    $(".deleteNotificationButton")
                        .off()
                        .on("click", function() {
                            let alarmId = $(this).attr("data-alarmid");
                            let fulldesc = $(this).attr("data-fulldesc");
                            console.log(
                                "Component(GeonotificationsHistory)::registerEventsOnSiteNotificationsTable(deleteNotificationButton) clicked. AlarmId = " +
                                    alarmId
                            );
                            self.showDeleteModal({
                                textContent: i18n.t(
                                    "geo_notif_deleteNotifConfirmText",
                                    { fulldesc: fulldesc }
                                ),
                                actionName: "DELETE_ALARM",
                                params: {
                                    siteId: self.siteId,
                                    alarmId: alarmId,
                                    limit: self.limit,
                                    offset: self.offset
                                }
                            });
                        });
                    $(".acknowledgeButton")
                        .off()
                        .on("click", function() {
                            let alarmId = $(this).attr("data-alarmid");
                            console.log(
                                "Component(GeonotificationsHistory)::registerEventsOnSiteNotificationsTable(acknowledgeButton) clicked. AlarmId = " +
                                    alarmId
                            );
                            // Hide and destroy element’s tooltip
                            $('[data-toggle="kt-tooltip"]').tooltip("dispose");
                            // Go to edit vue
                            self.onAcknowledgeAlarm(alarmId);
                        });
                    $(".editAssetButton")
                        .off()
                        .on("click", function() {
                            let assetId = $(this).attr("data-assetid");
                            console.log(
                                "Component(GeonotificationsHistory)::registerEventsOnSiteNotificationsTable(editAssetButton) clicked. assetId = " +
                                    assetId
                            );
                            // Hide and destroy element’s tooltip
                            $('[data-toggle="kt-tooltip"]').tooltip("dispose");
                            // Go to edit vue of asset
                            self.onEditAsset(assetId);
                        });
                    $(".editGeofenceButton")
                        .off()
                        .on("click", function() {
                            console.log(
                                "Component(GeonotificationsHistory)::registerEventsOnSiteNotificationsTable(editGeofenceButton) clicked."
                            );
                            // Hide and destroy element’s tooltip
                            $('[data-toggle="kt-tooltip"]').tooltip("dispose");
                            // Go to edit vue of asset
                            self.onEditGeofence();
                        });
                    $(".openLastPositionURLButton")
                        .off()
                        .on("click", function() {
                            const url = $(this).attr("data-url");
                            console.log(
                                "Component(GeonotificationsHistory)::registerEventsOnSiteNotificationsTable(openLastPositionURLButton) clicked."
                            );
                            self.onOpenLastPositionURLButton(url);
                        });
                    // Force width pager size
                    setTimeout(() => {
                        $(".kt-datatable__pager-size").css("width", "80px");
                        // Init tooltips
                        $('[data-toggle="kt-tooltip"]').tooltip({
                            trigger: "hover"
                        });
                    }, 50);
                }
            );
        },

        onExportGeoNotificationsHistory() {
            this.getGeonotificationAlarmsForSite({ siteId: this.siteId });
            this.isGetGeonotificationAlarmsForSiteToExport = true;
        },

        exportGeoNotificationsHistoryModal() {
            // Call common vueHelper function
            var data = [];
            // Creation of table header
            var header = [
                {name: i18n.t("geo_notif_description"), type: "STRING"},
                {name: i18n.t("geo_notif_notifStatus"), type: "STRING"},
                {name: i18n.t("geo_notif_assetName"), type: "STRING"},
                {name: i18n.t("geo_notif_geofenceName"), type: "STRING"},
                {name: i18n.t("geo_notif_geofenceThreshold"), type: "STRING"},
                {name: i18n.t("geo_notif_lastPosition"), type: "STRING"},
                {name: i18n.t("geo_notif_issuedAt"), type: "DATETIMEZONE"}
            ];

            this.siteAlarms.forEach(alarm => {
                // Checks the Full Description
                var fullDescription = null;
                if (alarm.value !== "THRESHOLD") {
                    fullDescription = alarm.assetName + " " + (alarm.value === "IN" ? i18n.t("alarm_in") : i18n.t("alarm_out")) +  " " + alarm.geofenceName;
                } else {
                    fullDescription = i18n.t("alarm_threshold", { geofenceName: alarm.geofenceName, threshold: alarm.geofenceThreshold })
                }

                // Checks if alarm is acknowledged
                var notificationStatus = (alarm.isAcknowledged) ? i18n.t("geo_notif_acknowledged") : i18n.t("geo_notif_unacknowledged");

                // Build data with all informations for this alarm
                const assetName = alarm.assetName ? alarm.assetName : "-";
                const threshold = alarm.geofenceThreshold > 0 ? alarm.geofenceThreshold : "-";

                // Set the right date format
                const issuedAt = moment(alarm.issuedAt).format(xlMomentDateFormat);

                var alarmInfo = [fullDescription, notificationStatus, assetName, alarm.geofenceName, threshold, alarm.lastPositionUrl, issuedAt];

                // Add in export data
                data.push(alarmInfo);
            });

            // Call common vueHelper function
            commonVueHelper.exportsDataToExcel(data, header, "notification-history", "notification-history");
        },

        formatSiteGeonotificationAlarms(siteAlarms) {
            // Prepare data
            let dataSource = [];
            if (siteAlarms) {
                dataSource = siteAlarms.map((alarm) => {
                    let customAlarm = {...alarm };
                    if (alarm.value === "THRESHOLD") {
                        customAlarm.translatedFullDescription = i18n.t("alarm_threshold", { geofenceName: alarm.geofenceName, threshold: alarm.geofenceThreshold });
                    } else {
                        customAlarm.translatedFullDescription = alarm.assetName + " " + (alarm.value === "IN" ? i18n.t("alarm_in") : i18n.t("alarm_out")) + " " + alarm.geofenceName;
                    }
                    if (alarm.isAcknowledged) {
                        customAlarm.notificationStatus = i18n.t("geo_notif_acknowledged");
                    } else {
                        customAlarm.notificationStatus = i18n.t("geo_notif_unacknowledged");
                    }
                    return customAlarm;
                });
            }
            return dataSource;
        },

        initKtDataTable() {
            console.log("Component(GeonotificationsHistory)::initKtDataTable - called");
            const options = {
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: this.baseURL + "/web/sites/" + this.siteId + '/alarms/geonotifications',
                            method: "GET",
                            params: {
                                pagination: {},
                                query: {}
                            },
                            headers: {
                                Authorization: this.authorization
                            },
                            map: (response) => {
                                this.setSiteAlarm({ alarms: response.data })
                                this.limit = response.meta.perpage;
                                this.offset = (response.meta.page - 1) * this.limit;
                                this.sort = response.meta.sort;
                                this.field = response.meta.field;

                                this.totalGeonotificationsHistory = response.meta.total;
                                this.unAcknowledgedGeonotificationsHistory = response.meta.unAcknowledged;
                                this.acknowledgedGeonotificationsHistory = response.meta.acknowledged;
                                this.lastHourNotificationsHistory = response.meta.inLastHour;

                                const dataSource = this.formatSiteGeonotificationAlarms(response.data);
                                return commonVueHelper.preventHtmlInjection(dataSource);
                            }
                        }
                    },
                    pageSize: 20,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    saveState: {
                        webstorage: false
                    }
                },
                layout: commonVueHelper.getLayoutOptions(),
                translate: commonVueHelper.getTranslateOptions(),
                toolbar: commonVueHelper.getToolbarOptions(),
                sortable: !0,
                pagination: !0,
                columns: [
                    {
                        field: "translatedFullDescription",
                        title: i18n.t("geo_notif_description"),
                        default: "-",
                        textAlign: "center",
                        overflow: "visible",
                        autoHide: false,
                        template: function(row) {
                            return (`<span class="d-inline-block text-truncate" style="max-width: 110%;" data-toggle="kt-tooltip" data-placement="top" title="${row.translatedFullDescription}">${row.translatedFullDescription}</span>`)
                        }
                    },
                    {
                        field: "isAcknowledged",
                        title: i18n.t("geo_notif_notifStatus"),
                        overflow: "visible",
                        textAlign: "center",
                        autoHide: false,
                        template: function(row) {
                            if (row.isAcknowledged) {
                                return (
                                    '<span class="kt-badge kt-badge--brand kt-badge--dot"></span>&nbsp;<span class="kt-font-bold kt-font-brand">' +
                                        row.notificationStatus +
                                    "</span>"
                                );
                            } else {
                                return (
                                    '<span class="kt-badge kt-badge--success kt-badge--dot"></span>&nbsp;<span class="kt-font-bold kt-font-success">' +
                                        row.notificationStatus +
                                    "</span>"
                                );
                            }
                        }
                    },
                    {
                        field: "assetName",
                        title: i18n.t("geo_notif_assetName"),
                        textAlign: "center",
                        template: function(row) {
                            if (row.asset) {
                                return (
                                    '\
                                    <div class="kt-user-card-v2">\
                                        <div class="kt-user-card-v2__details openResourceLink">\
                                            <a class="editAssetButton kt-link kt-user-card-v2__name" data-assetid="' +
                                    row.asset +
                                    '" href="javascript:;">' +
                                    row.assetName +
                                    "</a>\
                                        </div>\
                                    </div>\
                                "
                                );
                            } else {
                                return "-";
                            }
                        }
                    },
                    {
                        field: "geofenceName",
                        title: i18n.t("geo_notif_geofenceName"),
                        textAlign: "center",
                        template: function(row) {
                            if (row.geofence) {
                                return (
                                    '\
                                    <div class="kt-user-card-v2">\
                                        <div class="kt-user-card-v2__details openResourceLink">\
                                            <a class="editGeofenceButton kt-link kt-user-card-v2__name" href="javascript:;">' + row.geofenceName + "</a>\
                                        </div>\
                                    </div>\
                                "
                                );
                            } else {
                                return "-";
                            }
                        }
                    },
                    {
                        field: "lastPositionTimestamp",
                        title: i18n.t("geo_notif_lastPosition"),
                        textAlign: "center",
                        sortable: false,
                        overflow: "hidden",
                        autoHide: false,
                        template: function(row) {

                            if (row.lastPositionUrl && row.lastPositionTimestamp) {
                                return (`<div class="kt-user-card-v2">
                                            <div class="kt-user-card-v2__details openResourceLink" style="max-width: 100%; white-space: nowrap;">
                                                <a
                                                    class=" openLastPositionURLButton text-truncate kt-link kt-user-card-v2__name"
                                                    data-url= "${row.lastPositionUrl}"
                                                    href="javascript:;"
                                                >
                                                <span>${i18n.t("geo_notif_lastPositionUrl")}</span>
                                                </a>
                                            </div>
                                        </div>`
                                );
                            } else {
                                return "-";
                            }
                        }
                    },
                    {
                        field: "issuedAt",
                        title: i18n.t("geo_notif_issuedAt"),
                        textAlign: "center",
                        sortable: "desc",
                        template: function(row) {
                            if (row.issuedAt) {
                                const dateStringFormat = commonVueHelper.getDateStringFormatFromLocale( moment().locale() );
                                return moment(row.issuedAt).format(dateStringFormat);
                            } else {
                                return "-";
                            }
                        }
                    },
                    {
                        field: "Actions",
                        title: i18n.t("common_actions"),
                        sortable: false,
                        width: 110,
                        overflow: "visible",
                        autoHide: false,
                        textAlign: "center",
                        template: function(row) {
                            if (row.isAcknowledged) {
                                return (
                                    `
                                        <button data-toggle="kt-tooltip" data-placement="top" data-original-title="` +
                                    i18n.t("common_delete") +
                                    `" type="button" data-fulldesc="` +
                                    row.assetName +
                                    " " +
                                    (row.value === "IN"
                                        ? i18n.t("alarm_in")
                                        : i18n.t("alarm_out")) +
                                    " " +
                                    row.geofenceName +
                                    `" data-alarmid="` +
                                    row.id +
                                    `" class="btn btn-outline-danger btn-sm btn-icon deleteNotificationButton">
                                            <i class="la la-trash"></i>
                                        </button>
                                    `
                                );
                            } else {
                                return (
                                    `
                                    <button data-toggle="kt-tooltip" data-placement="top" data-original-title="` +
                                    i18n.t("common_acquit") +
                                    `" type="button" data-alarmid="` +
                                    row.id +
                                    `" class="btn btn-outline-brand btn-sm btn-icon acknowledgeButton">
                                            <i class="la la-check"></i>
                                        </button>
                                        <button data-toggle="kt-tooltip" data-placement="top" data-original-title="` +
                                    i18n.t("common_delete") +
                                    `" type="button" data-fulldesc="` +
                                    row.assetName +
                                    " " +
                                    (row.value === "IN"
                                        ? i18n.t("alarm_in")
                                        : i18n.t("alarm_out")) +
                                    " " +
                                    row.geofenceName +
                                    `" data-alarmid="` +
                                    row.id +
                                    `" class="btn btn-outline-danger btn-sm btn-icon deleteNotificationButton">
                                            <i class="la la-trash"></i>
                                        </button>
                                    `
                                );
                            }
                        }
                    }
                ]
            };

            // If site table has been already build, destroy the table before creating a fresh instance !
            if (this.siteNotificationsTable) {
                $("#notifications_datatable")
                    .KTDatatable()
                    .destroy();
                // After destroy set to null
                this.siteNotificationsTable = null;
            }

            // According to source list length, show datatable or empty list icon+text
            if (this.siteAlarms) {
                // There is data => Hide empty list icon+text
                this.isEmptyList = false;
                // Now, we are ready to build the table
                this.siteNotificationsTable = $(
                    "#notifications_datatable"
                ).KTDatatable(options);
                // Once table is build, register click events on buttons inside the table
                this.registerEventsOnSiteNotificationsTable();
            } else {
                // There is no data => Show empty list icon+text
                this.isEmptyList = true;
                this.siteNotificationsTable = null;
            }

        }
    },
    components: {
        // -- Components -- List of local components used in the current template
        // --
        "app-emptylist": EmptyList,
        "app-sitetitle": SiteTitle
    }
};
</script>

<style scoped>
.baseTemplate {
    display: contents;
}
</style>
